module.exports = __webpack_public_path__ + "static/media/kingdedede_0.bfe39e58.png";